import Vue from "vue";
import Ellipsis from "@hyjiacan/vue-ellipsis";

Vue.use(Ellipsis);
